<template>
  <v-expansion-panels accordion
                      v-model="openPanelIndex"
                      class="elevation-0 mb-4">
    <v-expansion-panel>

      <v-expansion-panel-header>
        <span class="text--secondary"><v-icon>mdi-filter</v-icon>{{ $t('actions.filters') }}</span>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container class="d-flex flex-wrap ma-0 pa-0 entity-view-filters" :class="$vuetify.breakpoint.name">
          <div class="d-inline-block entity-view-filter-item"
               v-for="slotName in filterSlotNames" :key="slotName">
            <slot :name="slotName"></slot>
          </div>
        </v-container>
        <v-btn v-if="isMobileLayout"
               block
               depressed
               x-small
               class="mt-3"
               @click="close">
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: 'EntityViewFilter',

  data() {
    return {
      openPanelIndex: 0,
    };
  },
  computed: {
    expanded() {
      return this.openPanelIndex === 0;
    },
    filterSlotNames() {
      //this is not the most elegant way of doing this, but can't get bette way to work right now
      const names = ['filter1', 'filter2', 'filter3', 'filter4', 'filter5'];
      return names.filter(name => this.hasSlot(name));
    },
    isMobileLayout() {
      return this.$vuetify.breakpoint.name === 'xs';
    },
  },
  methods: {
    hasSlot(name) {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },
    close() {
      this.openPanelIndex = null;
    },
  },
  created() {
    this.openPanelIndex = this.isMobileLayout ? null : 0; //default closed on mobile
  },

};
</script>

<style scoped>

.entity-view-filters > * {
  margin-top: 1em;
  margin-right: 3em;
}

.xs.entity-view-filters > * {
  margin-top: 1em;
  margin-right: 0;
}

</style>
